'use client';

import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import { useLocation } from 'react-router-dom';
import SuspenseWithLoader from '../SuspenseWithLoader';
import ProductListingPagePlaceholder from '../ProductListingPage/ProductListingPagePlaceholder';
import CategoryPageAlgolia from '../category-page-algolia';
import { PAGE_TYPE } from '../category-page-algolia/categoryPageTypes';
const stripLeadingAndTrailingSlash = path => {
  const pathWithoutLeadingSlash = path.startsWith('/') ? path.slice(1) : path;
  const pathWithoutTrailingSlash = pathWithoutLeadingSlash.endsWith('/') ? pathWithoutLeadingSlash.slice(0, -1) : pathWithoutLeadingSlash;
  return pathWithoutTrailingSlash;
};
const CategoryPage = t0 => {
  const $ = _c(14);
  const {
    slug: slugProp,
    serverCategoryData,
    pageType,
    algoliaUserToken,
    serverSeoResolved: t1,
    algoliaAnalyticsParams
  } = t0;
  const serverSeoResolved = t1 === undefined ? true : t1;
  const location = useLocation();
  const pathname = location?.pathname || "";
  let t2;
  if ($[0] !== pathname || $[1] !== slugProp) {
    t2 = slugProp || stripLeadingAndTrailingSlash(pathname);
    $[0] = pathname;
    $[1] = slugProp;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  const slug = t2;
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <ProductListingPagePlaceholder />;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== algoliaAnalyticsParams || $[5] !== algoliaUserToken || $[6] !== pageType || $[7] !== serverCategoryData || $[8] !== serverSeoResolved || $[9] !== slug) {
    t4 = <CategoryPageAlgolia key={slug} slug={slug} serverCategoryData={serverCategoryData} pageType={pageType} algoliaUserToken={algoliaUserToken} serverSeoResolved={serverSeoResolved} algoliaAnalyticsParams={algoliaAnalyticsParams} />;
    $[4] = algoliaAnalyticsParams;
    $[5] = algoliaUserToken;
    $[6] = pageType;
    $[7] = serverCategoryData;
    $[8] = serverSeoResolved;
    $[9] = slug;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== slug || $[12] !== t4) {
    t5 = <SuspenseWithLoader fallback={t3} key={slug}>{t4}</SuspenseWithLoader>;
    $[11] = slug;
    $[12] = t4;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
};
CategoryPage.propTypes = {
  slug: PropTypes.string,
  serverCategoryData: PropTypes.object,
  pageType: PropTypes.oneOf(Object.values(PAGE_TYPE)),
  algoliaUserToken: PropTypes.string,
  // False when the consumer app's generateMetadata could not resolve this
  // page's metadata, so the layout must emit the tags itself (CON-8801).
  serverSeoResolved: PropTypes.bool,
  algoliaAnalyticsParams: PropTypes.shape({
    analyticsTags: PropTypes.arrayOf(PropTypes.string),
    ruleContexts: PropTypes.arrayOf(PropTypes.string)
  })
};
export default CategoryPage;